/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  Switch,
  TextField
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useStyles } from './Styles'
import { useFormik } from 'formik'
import { addAdminFormValidation } from '../../../utils/validationSchema'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../Loader/FormLoader'
import { NamedRoutes } from '../../../routes'
import { Redirect } from 'react-router-dom'
import { ButtonLoader } from '../../Loader/ButtonLoader'

const AdminForm = ({ onSubmit, resetAddAdminStatus, roles }) => {
  const classes = useStyles()
  const intl = useIntl()
  const addAdminForm = useFormik({
    initialValues: {
      username: '',
      email: '',
      first_name: '',
      last_name: '',
      roles: [1],
      active: true
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: addAdminFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions)
    })
  })

  const [activeValue, setActiveValue] = React.useState(addAdminForm.values.active)
  const handleActiveChange = (event) => {
    setActiveValue(!JSON.parse(event.target.value))
    addAdminForm.setFieldValue('active', !JSON.parse(event.target.value))
  }
  React.useEffect(() => {
      if (!!resetAddAdminStatus) {
        resetAddAdminStatus()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  const [rolesValue, setRolesValue] = React.useState(roles.filter((role) => addAdminForm.values.roles.includes(role.id)))
  return (
    <AuthenticatedUserConsumer>
      {({ addAdminSuccess, adminSectionType }) => (
        <form onSubmit={addAdminForm.handleSubmit} noValidate autoComplete="off"
              className={classes.formWrapper}>

          {!!addAdminSuccess &&
          <Redirect to={NamedRoutes[adminSectionType].user.list}/>
          }

          <div className={classes.BasicInfoRow}>
            <InputLabel id="BasicInfo.username"> {<FormattedMessage id='Fields.label.username'/>} </InputLabel>
            <FormControl variant="outlined">
              <TextField
                placeholder={intl.formatMessage({ id: 'BasicInfo.placeholder.username' })}
                id="BasicInfo.username"
                type={'text'}
                margin="dense"
                variant="outlined"
                name='username'
                value={addAdminForm.username}
                onChange={addAdminForm.handleChange}
                onBlur={addAdminForm.handleBlur}
                helperText={addAdminForm.errors.username && addAdminForm.touched.username && addAdminForm.errors.username}
                error={addAdminForm.errors.username && addAdminForm.touched.username !== undefined}
              />
            </FormControl>
          </div>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="BasicInfo.email"> {<FormattedMessage id='Fields.label.email'/>} </InputLabel>
            <FormControl variant="outlined">
              <TextField
                placeholder={intl.formatMessage({ id: 'BasicInfo.placeholder.email' })}
                id="BasicInfo.email"
                type='email'
                margin="dense"
                variant="outlined"
                name='email'
                value={addAdminForm.email}
                onChange={addAdminForm.handleChange}
                onBlur={addAdminForm.handleBlur}
                helperText={addAdminForm.errors.email && addAdminForm.touched.email && addAdminForm.errors.email}
                error={addAdminForm.errors.email && addAdminForm.touched.email !== undefined}
              />
            </FormControl>
          </div>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="BasicInfo.firstName"> {<FormattedMessage id='Fields.label.firstName'/>} </InputLabel>
            <FormControl variant="outlined">
              <TextField
                placeholder={intl.formatMessage({ id: 'BasicInfo.placeholder.firstName' })}
                id="BasicInfo.firstName"
                type={'text'}
                margin="dense"
                variant="outlined"
                name='first_name'
                value={addAdminForm.first_name}
                onChange={addAdminForm.handleChange}
                onBlur={addAdminForm.handleBlur}
                helperText={addAdminForm.errors.first_name && addAdminForm.touched.first_name && addAdminForm.errors.first_name}
                error={addAdminForm.errors.first_name && addAdminForm.touched.first_name !== undefined}
              />
            </FormControl>
          </div>
          <div className={classes.BasicInfoRow}>
            <InputLabel id="BasicInfo.lastName"> {<FormattedMessage id='Fields.label.lastName'/>} </InputLabel>
            <FormControl variant="outlined">
              <TextField
                placeholder={intl.formatMessage({ id: 'BasicInfo.placeholder.lastName' })}
                id="BasicInfo.lastName"
                type={'text'}
                margin="dense"
                variant="outlined"
                name='last_name'
                value={addAdminForm.last_name}
                onChange={addAdminForm.handleChange}
                onBlur={addAdminForm.handleBlur}
                helperText={addAdminForm.errors.last_name && addAdminForm.touched.last_name && addAdminForm.errors.last_name}
                error={addAdminForm.errors.last_name && addAdminForm.touched.last_name !== undefined}
              />
            </FormControl>
          </div>


          <div className={classes.BasicInfoRow}>
            <InputLabel id="BasicInfoRow.roles"><FormattedMessage id='Fields.label.Roles'/></InputLabel>
            <Autocomplete
              multiple
              id="AdditionalInfo.Roles"
              loading={!roles}
              loadingText={<ButtonLoader loading={true}/>}
              options={roles.filter((role) => !!role.is_admin_role) || []}
              value={rolesValue}
              freeSolo
              disableCloseOnSelect
              getOptionLabel={(option) => option.name}
              onChange={(event, value) => {
                setRolesValue(value)
                let rolesIds = (!!value && !!value.length) ?
                  value.map(role => role.id) : []
                addAdminForm.setFieldTouched('roles', true, true)
                addAdminForm.setFieldValue('roles', rolesIds)
              }}
              renderOption={(option, { selected }) => (
                <React.Fragment>
                  <Checkbox
                    color={'primary'}
                    checked={addAdminForm.values.roles.includes(option.id)}
                  />
                  {option.name}
                </React.Fragment>
              )}
              renderInput={(params) => (
                <TextField {...params} variant="outlined"
                           placeholder={intl.formatMessage({ id: 'AdditionalInfo.placeholder.Roles' })}
                           name='role'
                           onChange={addAdminForm.handleChange}
                           onBlur={addAdminForm.handleBlur}
                           helperText={addAdminForm.errors.roles && addAdminForm.touched.roles && addAdminForm.errors.roles}
                           error={addAdminForm.errors.roles && addAdminForm.touched.roles !== undefined}
                />
              )}
            />
          </div>

          <div className={classes.BasicInfoRow}>
            <InputLabel id="BasicInfo.active"><FormattedMessage id='Users.List.Table.Active'/>:</InputLabel>
            <FormControl variant="outlined">
              <FormControlLabel
                label={activeValue ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })}
                value={activeValue ? true : false}
                control={
                  <Switch color="primary" checked={activeValue} value={activeValue ? true : false}/>
                }
                onChange={handleActiveChange}
              />
            </FormControl>
          </div>
          <div className={classes.SubmitRow}>
            <button type="submit" disabled={addAdminForm.isSubmitting || !addAdminForm.isValid}
                    className={classes.AddAdminSubmit}>
              <FormattedMessage id='AdditionalInfo.button.submit'/>
            </button>
          </div>
          {addAdminForm.isSubmitting && <FormLoader loading={true}/>}
        </form>
      )}
    </AuthenticatedUserConsumer>
  )
}

export default AdminForm
